import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import Stats from '@strava/ui/Stats';
import Stat from '@strava/ui/Stat';

import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import styles from './styles.scss';

const AthleteBanner = ({
  name,
  avatarUrl,
  location,
  followersCount,
  followAthleteUrl,
  totalDistance,
  distanceUnit,
  totalActivities,
  analyticsData
}) => (
  <div className={styles.bannerWrapper}>
    <div className={`container ${styles.bannerContainer}`}>
      <div className={styles.avatarWrapper}>
        <Avatar
          name={name}
          src={avatarUrl}
          type="athlete"
          className={styles.avatar}
        />
      </div>
      <div className={styles.detailsWrapper}>
        <h3 className={styles.name}>{name}</h3>
        <span className={styles.location}>{location}</span>
      </div>
      <div className={styles.followButtonWrapper}>
        <a
          className={`btn btn-primary ${styles.followBtn}`}
          href={followAthleteUrl}
          onClick={() =>
            trackV2({
              ...analyticsData,
              element: 'follow_on_strava',
              action: 'click'
            })
          }
        >
          {I18n.t('strava.athletes.show_public.follow_cta')}
        </a>
      </div>
      <Stats listClassName={styles.bannerStats}>
        <Stat label="Followers" value={followersCount} type="stat-xl" />
        {totalDistance && (
          <Stat
            label={`${distanceUnit.charAt(0).toUpperCase() +
              distanceUnit.slice(1)} in  ${new Date().getFullYear()}`}
            value={totalDistance}
            type="stat-xl"
          />
        )}
        {totalActivities ? (
          <Stat
            label={`Activities in ${new Date().getFullYear()}`}
            value={totalActivities}
            type="stat-xl"
          />
        ) : null}
      </Stats>
    </div>
  </div>
);

AthleteBanner.defaultProps = {
  totalDistance: null,
  totalActivities: null
};

AthleteBanner.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired,
  followersCount: PropTypes.number.isRequired,
  followAthleteUrl: PropTypes.string.isRequired,
  distanceUnit: PropTypes.string.isRequired,
  totalDistance: PropTypes.string,
  totalActivities: PropTypes.number,
  analyticsData: PropTypes.shape().isRequired
};

export default AthleteBanner;
